var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.1623 147.889C114.878 147.889 147.885 114.882 147.885 74.1666C147.885 33.4509 114.878 0.444336 74.1623 0.444336C33.4466 0.444336 0.440002 33.4509 0.440002 74.1666C0.440002 114.882 33.4466 147.889 74.1623 147.889Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1623 86.4554C59.3236 86.4554 49.4776 84.7271 37.3011 82.3598C34.5202 81.8232 29.1098 82.3598 29.1098 90.5511C29.1098 106.934 47.9294 127.412 74.1623 127.412C100.391 127.412 119.215 106.934 119.215 90.5511C119.215 82.3598 113.804 81.8191 111.023 82.3598C98.8469 84.7271 89.0009 86.4554 74.1623 86.4554Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3011 90.5498C37.3011 90.5498 49.5882 94.6455 74.1623 94.6455C98.7364 94.6455 111.023 90.5498 111.023 90.5498C111.023 90.5498 102.832 106.933 74.1623 106.933C45.4925 106.933 37.3011 90.5498 37.3011 90.5498Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5882 70.0711C55.2431 70.0711 59.8274 63.6532 59.8274 55.7363C59.8274 47.8193 55.2431 41.4014 49.5882 41.4014C43.9332 41.4014 39.349 47.8193 39.349 55.7363C39.349 63.6532 43.9332 70.0711 49.5882 70.0711Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7363 70.0711C104.391 70.0711 108.976 63.6532 108.976 55.7363C108.976 47.8193 104.391 41.4014 98.7363 41.4014C93.0814 41.4014 88.4971 47.8193 88.4971 55.7363C88.4971 63.6532 93.0814 70.0711 98.7363 70.0711Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellent);
export default __webpack_public_path__ + "static/media/excellent.163d44b8682d139a47b2ecb2cd089bd2.svg";
export { ForwardRef as ReactComponent };